module.exports = __webpack_public_path__ + "img/4-2-4-2-4-UK-preview-zannavandijk-e.70f55224.jpg";